module.exports = __webpack_public_path__ + "img/remate.5fd5e540.jpg";